/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnChanges, Output,
} from '@angular/core';
import { FeedStoreService } from '../../services/feed-store.service';
import type { PeopleKind } from '../community-profile.component';

// profile.followers and profile.following: people cards under the profile header, with a follow button each.
@Component({
  selector: 'ut-community-profile-people',
  templateUrl: './community-profile-people.component.html',
  styleUrls: ['./community-profile-people.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CommunityProfilePeopleComponent implements OnChanges {
  @Input({ required: true }) user: any;
  @Input({ required: true }) kind: PeopleKind;
  @Output() followChange = new EventEmitter<boolean>();

  store: any;

  constructor(
    @Inject('UserService') private UserService: any,
    private feedStore: FeedStoreService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(): void {
    const userId = this.user.id;
    this.store = this.kind === 'following'
      ? this.feedStore.create((params) => this.UserService.following(userId, params))
      : this.feedStore.create((params) => this.UserService.followers(userId, params));
    this.track(this.store.load());
  }

  subtitle(person: any): string {
    return [person.user_title, person.country?.name].filter(Boolean).join(' · ');
  }

  loadMore(): void {
    this.track(this.store.loadMore());
  }

  // FeedStore mutates in place, so re-render when a page starts and when it lands.
  private track(promise: any): void {
    this.cdr.markForCheck();
    promise.then(() => this.cdr.markForCheck());
  }
}
